module.exports = __webpack_public_path__ + "img/checked.fd1348ed.svg";